import { SET } from './constants'
import Setting from './model'

export const setAction = (settings: Setting) => ({
  type: SET,
  settings,
})
